import {UserLevel} from '@netx/core-user/constants';

export const PAGE_SIZE = 25;

export enum DownloadRequestsPref {
	SORT_FIELD = 'downloadRequest.sortField',
	SORT_ORDER = 'downloadRequest.sortOrder',
	FILTER_STATUS = 'downloadRequest.filterStatus',
}

export const DOWNLOAD_REQUESTS_MANAGE_MINIMUM_USER_LEVEL = UserLevel.DIRECTOR;
